import { gql } from "@apollo/client";
import { ASSET_INFO, BET_OPTION_INFO, ROOM_INFO } from "../fragments";

export const GET_ASSET_LIST = gql`
  query assetList {
    assetList {
      ...assetInfo
    }
  }
  ${ASSET_INFO}
`;

export const GET_ROOM_LIST = gql`
  query roomList($asset: ID!) {
    roomList(asset: $asset) {
      ...roomInfo
    }
  }
  ${ROOM_INFO}
`;

export const GET_BET_OPTION_LIST = gql`
  query betOptionList {
    betOptionList {
      ...betOptionInfo
    }
  }
  ${BET_OPTION_INFO}
`;
